import { render, staticRenderFns } from "./AdditionalPaymentSlip.vue?vue&type=template&id=4fe3861e&"
import script from "./AdditionalPaymentSlip.vue?vue&type=script&lang=js&"
export * from "./AdditionalPaymentSlip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports